import { useCallback } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { createCategory, updateCategory } from "../api/category.api";
import type { Category, CategoryPayload } from "../types/category.types";

export function useSaveCategory() {
  const { run, loading } = useLatestRequest();

  const execute = useCallback(
    async (id: string | undefined, payload: CategoryPayload): Promise<Category | undefined> => {
      return run(async () => {
        if (id) return updateCategory(id, payload);
        return createCategory(payload);
      });
    },
    [run],
  );

  return { execute, isLoading: loading };
}
